module.exports = __webpack_public_path__ + "img/03-round-not-convex-2.c7697bd4.svg";